var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import { FormGroup, Grid, MenuItem, Select, TextField, } from "@mui/material";
import Button from "@mui/material/Button";
import { DialogConfimarcaoAnistia } from "../DialogConfimarcaoAnistia";
function createData(id, numeroConta, estado, conta, numeroDocumento, periodo, valorDivida, valorImposto, multa, juros, impostoAnistia, multaAnistia, jurosAnistia) {
    return {
        id: id,
        numeroConta: numeroConta,
        estado: estado,
        conta: conta,
        numeroDocumento: numeroDocumento,
        periodo: periodo,
        valorDivida: valorDivida,
        valorImposto: valorImposto,
        multa: multa,
        juros: juros,
        impostoAnistia: impostoAnistia,
        multaAnistia: multaAnistia,
        jurosAnistia: jurosAnistia,
    };
}
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
function getComparator(order, orderBy) {
    return order === "desc"
        ? function (a, b) { return descendingComparator(a, b, orderBy); }
        : function (a, b) { return -descendingComparator(a, b, orderBy); };
}
// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
    var stabilizedThis = array.map(function (el, index) { return [el, index]; });
    stabilizedThis.sort(function (a, b) {
        var order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map(function (el) { return el[0]; });
}
var headCells = [
    {
        id: "conta",
        numeric: false,
        disablePadding: true,
        label: "Conta",
    },
    {
        id: "numeroDocumento",
        numeric: true,
        disablePadding: false,
        label: "N° Documento",
    },
    {
        id: "periodo",
        numeric: true,
        disablePadding: false,
        label: "Período",
    },
    {
        id: "valorDivida",
        numeric: true,
        disablePadding: false,
        label: "Valor Dívida",
    },
    {
        id: "valorImposto",
        numeric: true,
        disablePadding: false,
        label: "Valor Imposto",
    },
    {
        id: "multa",
        numeric: true,
        disablePadding: false,
        label: "Multa",
    },
    {
        id: "juros",
        numeric: true,
        disablePadding: false,
        label: "Juros",
    },
    {
        id: "impostoAnistia",
        numeric: true,
        disablePadding: false,
        label: "Imposto Anistia",
    },
    {
        id: "multaAnistia",
        numeric: true,
        disablePadding: false,
        label: "Multa Anistia",
    },
    {
        id: "jurosAnistia",
        numeric: true,
        disablePadding: false,
        label: "Juros Anistia",
    },
];
function EnhancedTableHead(props) {
    var onSelectAllClick = props.onSelectAllClick, order = props.order, orderBy = props.orderBy, numSelected = props.numSelected, rowCount = props.rowCount, onRequestSort = props.onRequestSort;
    var createSortHandler = function (property) { return function (event) {
        onRequestSort(event, property);
    }; };
    return (_jsx(TableHead, __assign({ sx: { background: "#034ea2", color: "white" } }, { children: _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ padding: "checkbox" }, { children: _jsx(Checkbox, { color: "warning", indeterminate: numSelected > 0 && numSelected < rowCount, checked: rowCount > 0 && numSelected === rowCount, onChange: onSelectAllClick, inputProps: {
                            "aria-label": "select all desserts",
                        } }) })), headCells.map(function (headCell) { return (_jsx(TableCell, __assign({ sx: { background: "#034ea2", color: "white" }, align: headCell.numeric ? "right" : "left", padding: headCell.disablePadding ? "none" : "normal", sortDirection: orderBy === headCell.id ? order : false }, { children: _jsxs(TableSortLabel, __assign({ active: orderBy === headCell.id, direction: orderBy === headCell.id ? order : "asc", onClick: createSortHandler(headCell.id) }, { children: [headCell.label, orderBy === headCell.id ? (_jsx(Box, __assign({ component: "span", sx: visuallyHidden }, { children: order === "desc" ? "sorted descending" : "sorted ascending" }))) : null] })) }), headCell.id)); })] }) })));
}
function EnhancedTableToolbar(props) {
    var numSelected = props.numSelected;
    return (_jsxs(Toolbar, __assign({ sx: __assign({ pl: { sm: 2 }, pr: { xs: 1, sm: 1 } }, (numSelected > 0 && {
            bgcolor: function (theme) {
                return alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity);
            },
        })) }, { children: [numSelected > 0 ? (_jsxs(Typography, __assign({ sx: { flex: "1 1 100%" }, color: "inherit", variant: "subtitle1", component: "div" }, { children: [numSelected, " selected"] }))) : (_jsx(Typography, __assign({ sx: { flex: "1 1 100%" }, variant: "h6", id: "tableTitle", component: "div" }, { children: "Lista de D\u00E9bitos" }))), numSelected > 0 ? (_jsx(Tooltip, __assign({ title: "Delete" }, { children: _jsx(IconButton, { children: _jsx(DeleteIcon, {}) }) }))) : (_jsx(Tooltip, __assign({ title: "Filter list" }, { children: _jsx(IconButton, { children: _jsx(FilterListIcon, {}) }) })))] })));
}
var borda = {
    border: "1px solid #45444477",
    borderRadius: "6px",
    width: "100%",
    marginBottom: "1rem",
};
export default function TableListDebitosNovo(_a) {
    var anistias = _a.anistias;
    var _b = React.useState("asc"), order = _b[0], setOrder = _b[1];
    var _c = React.useState("id"), orderBy = _c[0], setOrderBy = _c[1];
    var _d = React.useState([]), selected = _d[0], setSelected = _d[1];
    var _e = React.useState(0), page = _e[0], setPage = _e[1];
    var _f = React.useState(false), dense = _f[0], setDense = _f[1];
    var _g = React.useState(5), rowsPerPage = _g[0], setRowsPerPage = _g[1];
    var _h = React.useState([]), selectedRows = _h[0], setSelectedRows = _h[1];
    var _j = React.useState("integral"), selectedOption = _j[0], setSelectedOption = _j[1];
    var _k = React.useState(""), parcelas = _k[0], setParcelas = _k[1];
    var _l = React.useState(0), regraPercentual = _l[0], setRegraPercentual = _l[1];
    var _m = React.useState(""), age = _m[0], setAge = _m[1];
    var _o = React.useState(false), open = _o[0], setOpen = _o[1];
    var _p = React.useState(0), valorMinimo = _p[0], setValorMinimo = _p[1];
    var handleOpen = function () { return setOpen(true); };
    var handleClose = function () { return setOpen(false); };
    var percentual = 0;
    var handleOptionChange = function (event) {
        setSelectedOption(event.target.value);
    };
    var rows = [
        createData(1, 2, 3, "CONTA-TESTE", 305, 3.7, "", "", "0", "0", "0", "0", "0"),
    ];
    if (anistias && anistias.debitos) {
        rows = __spreadArray([], anistias.debitos.map(function (debito) {
            return createData(parseInt(debito.idConta), debito.conta, debito.estado, debito.descricaoConta, debito.numeroDocumento, debito.periodo, "R$ " + formataParaDinheiro(debito.valorTotal), "R$ " + formataParaDinheiro(debito.valorPrincipal), "R$ " + formataParaDinheiro(debito.valorMulta), "R$ " + formataParaDinheiro(debito.valorJuros), "R$ " + formataParaDinheiro(debito.valorPrincipal), selectedRows.length === 0
                ? "R$ 0"
                : "R$ " + formataParaDinheiro(debito.valorMulta * regraPercentual), selectedRows.length === 0
                ? "R$ 0"
                : "R$ " + formataParaDinheiro(debito.valorJuros * regraPercentual));
        }), true);
    }
    React.useEffect(function () {
        var filterSelectedRows = function () {
            var filteredRows = rows.filter(function (row) { return selected.includes(row.id); });
            setSelectedRows(filteredRows);
        };
        if ((anistias === null || anistias === void 0 ? void 0 : anistias.ufrAtual) && anistias.parcelaMinima) {
            setValorMinimo(anistias.parcelaMinima * (anistias === null || anistias === void 0 ? void 0 : anistias.ufrAtual));
        }
        var regras = anistias === null || anistias === void 0 ? void 0 : anistias.regras;
        var nomeRegraDesejada = nomeRegraPorOpcao[selectedOption];
        var regra = regras === null || regras === void 0 ? void 0 : regras.find(function (regra) { return regra.nomeRegra === nomeRegraDesejada; });
        setRegraPercentual((regra === null || regra === void 0 ? void 0 : regra.percentual) || 0);
        filterSelectedRows();
        function getDefaultValue(selectedOption) {
            if (selectedOption === "integral") {
                setParcelas(String(1));
                return 1;
            }
            if (selectedOption === "3meses") {
                setParcelas(String(2));
                return 2;
            }
            if (selectedOption === "6meses") {
                setParcelas(String(4));
                return 4;
            }
            if (selectedOption === "12meses") {
                setParcelas(String(7));
                return 7;
            }
            return 1;
        }
        getDefaultValue(selectedOption);
    }, [selected, selectedOption, valorMinimo]);
    var totalValorDivida = selectedRows.reduce(function (total, item) {
        var valorDivida = parseFloat(item.valorDivida
            .replace("R$", "")
            .replace(".", "")
            .replace(",", ".")
            .trim());
        return total + valorDivida;
    }, 0);
    var totalValorImposto = selectedRows.reduce(function (total, item) {
        var valorImposto = parseFloat(item.valorImposto
            .replace("R$", "")
            .replace(".", "")
            .replace(",", ".")
            .trim());
        return total + valorImposto;
    }, 0);
    var totalValorMulta = selectedRows.reduce(function (total, item) {
        var valorMulta = parseFloat(item.multa.replace("R$", "").replace(".", "").replace(",", ".").trim());
        return total + valorMulta;
    }, 0);
    var totalValorJuros = selectedRows.reduce(function (total, item) {
        var totalValorJuros = parseFloat(item.juros.replace("R$", "").replace(".", "").replace(",", ".").trim());
        return total + totalValorJuros;
    }, 0);
    function formataParaDinheiro(valor) {
        return valor.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }
    function formataParaDinheiroBr(valor) {
        return valor.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }
    var handleRequestSort = function (event, property) {
        var isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    var handleSelectAllClick = function (event) {
        if (event.target.checked) {
            var newSelected = rows.map(function (n) { return n.id; });
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };
    var handleClick = function (event, id) {
        var selectedIndex = selected.indexOf(id);
        var newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        }
        else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        }
        else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        }
        else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
    };
    var handleChangePage = function (event, newPage) {
        setPage(newPage);
    };
    var handleChangeRowsPerPage = function (event) {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    var isSelected = function (id) { return selected.indexOf(id) !== -1; };
    var nomeRegraPorOpcao = {
        integral: "PAGAMENTO NORMAL",
        "3meses": "PAGAMENTO EM ATÉ 3 MESES",
        "6meses": "PAGAMENTO EM ATÉ 6 MESES",
        "12meses": "PAGAMENTO EM ATÉ 12 MESES",
    };
    function calculaValorTotalDividaDaAnistia(valorImposto, valorMulta, valorJuros) {
        var regras = anistias === null || anistias === void 0 ? void 0 : anistias.regras;
        var nomeRegraDesejada = nomeRegraPorOpcao[selectedOption];
        var regra = regras === null || regras === void 0 ? void 0 : regras.find(function (regra) { return regra.nomeRegra === nomeRegraDesejada; });
        var percentual = (regra === null || regra === void 0 ? void 0 : regra.percentual) || 0;
        var total = valorImposto + valorMulta * percentual + valorJuros * percentual;
        return total;
    }
    function adicionaPercentualAMultaEJuros(valor) {
        var regras = anistias === null || anistias === void 0 ? void 0 : anistias.regras;
        var nomeRegraDesejada = nomeRegraPorOpcao[selectedOption];
        var regra = regras === null || regras === void 0 ? void 0 : regras.find(function (regra) { return regra.nomeRegra === nomeRegraDesejada; });
        percentual = (regra === null || regra === void 0 ? void 0 : regra.percentual) || 0;
        return valor * percentual;
    }
    var handleChange = function (event) {
        console.log(event.target.value);
        setAge(event.target.value);
        setParcelas(event.target.value);
    };
    return (_jsxs(Box, __assign({ sx: { width: "100%" } }, { children: [_jsxs("div", __assign({ style: borda }, { children: [_jsxs(Paper, __assign({ sx: { width: "100%", mb: 2 } }, { children: [_jsx(Typography
                            // align="left"
                            , __assign({ 
                                // align="left"
                                pt: 1, sx: {
                                    flex: "1 1 100%",
                                    backgroundColor: "#034ea2",
                                    color: "white",
                                    fontWeight: "bold",
                                }, pl: 2, variant: "h6", id: "tableTitle", component: "div" }, { children: "Lista de D\u00E9bitos" })), _jsx(TableContainer, { children: _jsxs(Table, __assign({ sx: { minWidth: 750 }, "aria-labelledby": "tableTitle", size: dense ? "small" : "medium" }, { children: [_jsx(EnhancedTableHead, { numSelected: selected.length, order: order, orderBy: orderBy, onSelectAllClick: handleSelectAllClick, onRequestSort: handleRequestSort, rowCount: rows.length }), _jsx(TableBody, { children: rows.map(function (row, index) {
                                                var isItemSelected = isSelected(row.id);
                                                var labelId = "enhanced-table-checkbox-".concat(index);
                                                return (_jsxs(TableRow, __assign({ hover: true, onClick: function (event) { return handleClick(event, row.id); }, role: "checkbox", "aria-checked": isItemSelected, tabIndex: -1, selected: isItemSelected, sx: { cursor: "pointer" } }, { children: [_jsx(TableCell, __assign({ padding: "checkbox" }, { children: _jsx(Checkbox, { color: "primary", checked: isItemSelected, inputProps: {
                                                                    "aria-labelledby": labelId,
                                                                } }) })), _jsx(TableCell, __assign({ component: "th", id: labelId, scope: "row", padding: "none" }, { children: row.conta })), _jsx(TableCell, __assign({ align: "right" }, { children: row.numeroDocumento })), _jsx(TableCell, __assign({ align: "right" }, { children: row.periodo })), _jsx(TableCell, __assign({ align: "right" }, { children: row.valorDivida })), _jsx(TableCell, __assign({ align: "right" }, { children: row.valorImposto })), _jsx(TableCell, __assign({ align: "right" }, { children: row.multa })), _jsx(TableCell, __assign({ align: "right" }, { children: row.juros })), _jsx(TableCell, __assign({ align: "right" }, { children: row.impostoAnistia })), _jsx(TableCell, __assign({ align: "right" }, { children: row.multaAnistia })), _jsx(TableCell, __assign({ align: "right" }, { children: row.jurosAnistia }))] }), row.id + row.numeroConta));
                                            }) })] })) })] })), _jsxs(Grid, __assign({ container: true, p: 2, xs: 12 }, { children: [_jsx(Grid, __assign({ alignItems: "center", container: true, xs: 12, sm: 12, md: 2, lg: 2 }, { children: _jsx(Grid, __assign({ item: true, xs: 12, mb: 2 }, { children: _jsxs(Typography, __assign({ align: "center" }, { children: [selectedRows.length, " Divida(s) selecionadas"] })) })) })), _jsxs(Grid, __assign({ container: true, xs: 12, sm: 12, md: 10, lg: 10, alignItems: "center", spacing: 2 }, { children: [_jsxs(Grid, __assign({ item: true, xs: 6, sm: 3, md: 3, lg: 3 }, { children: [_jsx(Typography, __assign({ align: "left" }, { children: "Total D\u00EDvida" })), _jsx(TextField, { fullWidth: true, value: "R$ ".concat(formataParaDinheiroBr(totalValorDivida)), id: "outlined-basic", variant: "outlined", InputProps: {
                                                    readOnly: true,
                                                } })] })), _jsxs(Grid, __assign({ item: true, xs: 6, sm: 3, md: 3, lg: 3 }, { children: [_jsx(Typography, __assign({ align: "left" }, { children: "Total Imposto" })), _jsx(TextField, { fullWidth: true, value: "R$ ".concat(formataParaDinheiroBr(totalValorImposto)), id: "outlined-basic", variant: "outlined", InputProps: {
                                                    readOnly: true,
                                                } })] })), _jsxs(Grid, __assign({ item: true, xs: 6, sm: 3, md: 3, lg: 3 }, { children: [_jsx(Typography, __assign({ align: "left" }, { children: "Total Multa" })), _jsx(TextField, { fullWidth: true, value: "R$ ".concat(formataParaDinheiroBr(totalValorMulta)), id: "outlined-basic", variant: "outlined", InputProps: {
                                                    readOnly: true,
                                                } })] })), _jsxs(Grid, __assign({ item: true, xs: 6, sm: 3, md: 3, lg: 3 }, { children: [_jsx(Typography, __assign({ align: "left" }, { children: "Total Juros" })), _jsx(TextField, { fullWidth: true, value: "R$ ".concat(formataParaDinheiroBr(totalValorJuros)), id: "outlined-basic", variant: "outlined", InputProps: {
                                                    readOnly: true,
                                                } })] }))] }))] }))] })), _jsxs("div", __assign({ style: borda }, { children: [_jsx(Grid, __assign({ container: true, p: 1, sx: { background: "#034ea2" } }, { children: _jsx(Typography, __assign({ sx: { flex: "1 1 100%", color: "white", fontWeight: "bold" }, variant: "h6", id: "tableTitle", component: "div" }, { children: "Calculo Anistia" })) })), _jsxs(Grid, __assign({ container: true, p: 2 }, { children: [_jsx(Grid, __assign({ container: true, p: 2, xs: 12, md: 4, lg: 3 }, { children: _jsxs(FormGroup, { children: [_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: selectedOption === "integral", onChange: handleOptionChange, value: "integral" }), label: "Pagamento Integral" }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: selectedOption === "3meses", onChange: handleOptionChange, value: "3meses" }), label: "Pagamento em at\u00E9 3 meses" }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: selectedOption === "6meses", onChange: handleOptionChange, value: "6meses" }), label: "Pagamento em at\u00E9 6 meses" }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: selectedOption === "12meses", onChange: handleOptionChange, value: "12meses" }), label: "Pagamento em at\u00E9 12 meses" })] }) })), _jsxs(Grid, __assign({ container: true, xs: 12, md: 8, lg: 9 }, { children: [_jsxs(Grid, __assign({ container: true, xs: 12, spacing: 2 }, { children: [_jsxs(Grid, __assign({ item: true, xs: 6, sm: 6, md: 6, lg: 3 }, { children: [_jsx(Typography, __assign({ align: "left", style: {} }, { children: "Total D\u00EDvida" })), _jsx(TextField, { value: "R$ ".concat(formataParaDinheiro(calculaValorTotalDividaDaAnistia(totalValorImposto, totalValorMulta, totalValorJuros))), id: "outlined-basic", variant: "outlined", fullWidth: true, InputProps: {
                                                            readOnly: true,
                                                        } })] })), _jsxs(Grid, __assign({ item: true, xs: 6, sm: 6, md: 6, lg: 3 }, { children: [_jsx(Typography, __assign({ align: "left", style: {} }, { children: "Total Imposto" })), _jsx(TextField, { value: "R$ ".concat(formataParaDinheiroBr(totalValorImposto)), id: "outlined-basic", variant: "outlined", fullWidth: true, InputProps: {
                                                            readOnly: true,
                                                        } })] })), _jsxs(Grid, __assign({ item: true, xs: 6, sm: 6, md: 6, lg: 3, style: { marginBottom: "20px" } }, { children: [_jsx(Typography, __assign({ align: "left", style: {} }, { children: "Total Multa" })), _jsx(TextField, { value: "R$ ".concat(formataParaDinheiro(adicionaPercentualAMultaEJuros(totalValorMulta))), id: "outlined-basic", variant: "outlined", fullWidth: true, InputProps: {
                                                            readOnly: true,
                                                        } })] })), _jsxs(Grid, __assign({ item: true, xs: 6, sm: 6, md: 6, lg: 3, style: { marginBottom: "20px" } }, { children: [_jsx(Typography, __assign({ align: "left", style: {} }, { children: "Total Juros" })), _jsx(TextField, { value: "R$ ".concat(formataParaDinheiro(adicionaPercentualAMultaEJuros(totalValorJuros))), id: "outlined-basic", variant: "outlined", fullWidth: true, InputProps: {
                                                            readOnly: true,
                                                        } })] }))] })), _jsxs(Grid, __assign({ container: true, xs: 12, md: 6, lg: 9, spacing: 2 }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12, sm: 6, md: 6, lg: 3 }, { children: [_jsx(Typography, __assign({ align: "left" }, { children: "Parc.:" })), _jsxs(Select, __assign({ labelId: "demo-simple-select-label", id: "demo-simple-select", 
                                                        // value={getDefaultValue(selectedOption).toString()}
                                                        value: parcelas, label: "Parcela", fullWidth: true, onChange: handleChange }, { children: [selectedOption === "integral" && [
                                                                _jsx(MenuItem, __assign({ value: "1" }, { children: "1" }), 1),
                                                            ], selectedOption === "3meses" && [
                                                                _jsx(MenuItem, __assign({ value: "2" }, { children: "2" }), 2),
                                                                _jsx(MenuItem, __assign({ value: "3" }, { children: "3" }), 3),
                                                            ], selectedOption === "6meses" && [
                                                                _jsx(MenuItem, __assign({ value: "4" }, { children: "4" }), 4),
                                                                _jsx(MenuItem, __assign({ value: "5" }, { children: "5" }), 5),
                                                                _jsx(MenuItem, __assign({ value: "6" }, { children: "6" }), 6),
                                                            ], selectedOption === "12meses" && [
                                                                _jsx(MenuItem, __assign({ value: "7" }, { children: "7" }), 7),
                                                                _jsx(MenuItem, __assign({ value: "8" }, { children: "8" }), 8),
                                                                _jsx(MenuItem, __assign({ value: "9" }, { children: "9" }), 9),
                                                                _jsx(MenuItem, __assign({ value: "10" }, { children: "10" }), 10),
                                                                _jsx(MenuItem, __assign({ value: "11" }, { children: "11" }), 11),
                                                                _jsx(MenuItem, __assign({ value: "12" }, { children: "12" }), 12),
                                                            ]] }))] })), _jsxs(Grid, __assign({ item: true, xs: 12, sm: 6, md: 6, lg: 3 }, { children: [_jsx(Typography, __assign({ align: "left" }, { children: "Valor da parcela" })), _jsx(TextField, { value: "R$ ".concat(formataParaDinheiro(calculaValorTotalDividaDaAnistia(totalValorImposto, totalValorMulta, totalValorJuros) / parseInt(parcelas))), id: "outlined-basic", variant: "outlined", fullWidth: true, InputProps: {
                                                            readOnly: true,
                                                        } })] })), totalValorDivida / parseInt(parcelas) < valorMinimo && (_jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsxs(Typography, __assign({ color: "red" }, { children: ["O valor m\u00EDnimo de cada parcela deve ser de R$", " ", formataParaDinheiro(valorMinimo), " (", anistias === null || anistias === void 0 ? void 0 : anistias.parcelaMinima, " UFR)"] })) })))] }))] }))] })), _jsx(Grid, __assign({ container: true, justifyContent: "center", p: 2 }, { children: _jsx(Button, __assign({ variant: "contained", disabled: totalValorDivida === 0 ||
                                totalValorDivida / parseInt(parcelas) < valorMinimo, onClick: handleOpen }, { children: "Confirma Calculo" })) }))] })), open && (_jsx(DialogConfimarcaoAnistia, { handleClose: handleClose, handleOpen: handleOpen, debitos: selectedRows, totalDivida: totalValorDivida, totalImposto: totalValorImposto, totalMulta: totalValorMulta, totalJuros: totalValorJuros, regras: (anistias === null || anistias === void 0 ? void 0 : anistias.regras) || [], parcela: selectedOption, numParcelas: parseInt(parcelas), data: anistias }))] })));
}
